function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("style", null, ".AE_Ic_Soluciones_Suministro_energ\xEDa_renovable_svg__st0{fill:#1d1d1b}");

var _ref2 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M15.1 18.3H8.9c-.3 0-.6-.2-.7-.6-.2-1-.8-2-1.7-2.9C4.6 13.1 3.7 10.6 4 8c.4-3.8 3.5-6.8 7.3-7.3.4-.1.7-.1 1.1 0h.3c3.8.5 6.9 3.5 7.3 7.3.3 2.6-.6 5.1-2.5 6.8-.9.9-1.5 1.9-1.7 2.9-.1.4-.4.6-.7.6zm-5.9-1h5.7c.3-1.1 1-2.2 2-3.2 1.6-1.6 2.4-3.8 2.2-6-.4-3.3-3.1-6-6.4-6.4h-1.2C8.1 2.1 5.4 4.8 5 8.1c-.2 2.3.6 4.4 2.2 6 1 1 1.7 2.1 2 3.2z"
});

var _ref3 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  className: "AE_Ic_Soluciones_Suministro_energ\\xEDa_renovable_svg__st0",
  d: "M11.4 13h1v4.4h-1z"
});

var _ref4 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  className: "AE_Ic_Soluciones_Suministro_energ\\xEDa_renovable_svg__st0",
  d: "M12.7 13.2H12c-.2 0-.3-.1-.4-.3 0-.1-1-2.3.1-4.3.8-1.5 2.5-2.4 5-2.8.3 0 .5.1.6.4 0 .1.8 3.6-1 5.6-1 1-2.1 1.4-3.6 1.4zm-.3-1c1.3.1 2.4-.3 3-1 1.1-1.3 1-3.4.9-4.3-1.9.4-3.2 1.1-3.7 2.2-.7 1.2-.4 2.6-.2 3.1z"
});

var _ref5 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  className: "AE_Ic_Soluciones_Suministro_energ\\xEDa_renovable_svg__st0",
  d: "M11.6 13.4c-1.2 0-2.2-.4-2.9-1.1-1.4-1.4-1.4-3.5-1.4-3.6 0-.3.2-.5.5-.5.1 0 3.7-.1 4.3 2.4.1.3-.1.5-.4.6-.3.1-.5-.1-.6-.4-.3-1.3-2-1.6-2.8-1.6.1.6.3 1.6 1.1 2.3.6.6 1.4.8 2.4.8l3.6-4.5c.2-.2.5-.3.7-.1.2.2.3.5.1.7l-3.7 4.7c-.1.1-.2.2-.4.2-.3.1-.4.1-.5.1z"
});

var _ref6 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M12.5 23.3h-1c-1.8 0-3.3-1.5-3.3-3.3v-2.6h1V20c0 1.3 1 2.3 2.3 2.3h1c1.3 0 2.3-1 2.3-2.3v-2.6h1V20c0 1.8-1.5 3.3-3.3 3.3z"
});

var _ref7 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  className: "AE_Ic_Soluciones_Suministro_energ\\xEDa_renovable_svg__st0",
  d: "M8.7 18.9h6.6v1H8.7zM8.7 20.4h6.6v1H8.7z"
});

var SvgAeIcSolucionesSuministroenergarenovable = function SvgAeIcSolucionesSuministroenergarenovable(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "AE_Ic_Soluciones_Suministro_energ\\xEDa_renovable_svg__Capa_1",
    x: 0,
    y: 0,
    viewBox: "0 0 24 24",
    xmlSpace: "preserve"
  }, props), _ref, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7);
};

export default "data:image/svg+xml;base64,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";
export { SvgAeIcSolucionesSuministroenergarenovable as ReactComponent };